import { formatElapsedTime } from 'utils/utils';
import { H5, H6, P } from '../Text';
import moment from 'moment';
import { useTranslation } from 'next-i18next/pages';

interface IFlightRouteStopProps {
  time: string;
  title: string;
  icon?: any;
  className?: string;
  lastFlightStop?: boolean;
  details?: React.JSX.Element;
  elapsedTime: string | null;
  joinDetails?: string[];
  dateTime?: string;
  newDate?: string;
}

const FlightRouteStop: React.FC<IFlightRouteStopProps> = (
  props: IFlightRouteStopProps,
) => {
  const {
    time,
    title,
    icon,
    className,
    lastFlightStop,
    details,
    elapsedTime,
    dateTime,
    newDate,
    joinDetails,
  } = props;
  const { t, i18n } = useTranslation();
  return (
    <div className="flex flex-col">
      {dateTime && (
        <div className="flex space-x-[22px]">
          <P className={newDate ? 'line-through' : ''}>
            {moment(dateTime).locale(i18n.language).format('ll')}
          </P>
          {newDate && (
            <P className="text-green-600">
              {t('New date')}:{' '}
              {moment(newDate)
                .locale(i18n.language)
                .format('lll')}
            </P>
          )}
        </div>
      )}
      <div className={`flex space-x-3 ${className || 'min-h-[3rem]'}`}>
        <div className="flex flex-col w-[4.5rem] shrink-0">
          <P className={newDate ? 'line-through' : ''}>{time}</P>
          {elapsedTime && (
            <P
              className={`text-left whitespace-nowrap text-tt-light-gray-purple ${
                newDate ? 'line-through' : ''
              }`}>
              {formatElapsedTime(elapsedTime, t)}
            </P>
          )}
        </div>
        <div className="flex flex-col mt-[2px]">
          <div>{icon}</div>
          {/* <Image src={icon} alt={title} className="w-6 h-6" /> */}
          {!lastFlightStop && (
            <div className="h-6 mt-1 ml-2 border-l border-tt-light-gray-purple-line grow"></div>
          )}
        </div>
        {joinDetails ? (
          <div className="flex w-full flex-col">
            <P>{title}</P>
            <H6 className="text-tt-light-gray-purple leading-[1.4rem]">
              {joinDetails?.join(' | ')}
            </H6>
          </div>
        ) : (
          <div className="flex w-full flex-col">
            <P>{title}</P>
            {details && details}
          </div>
        )}
      </div>
    </div>
  );
};

export default FlightRouteStop;
